"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _uiBox = require("ui-box");

var _formField = require("../../form-field");

var _TextInput = _interopRequireDefault(require("./TextInput"));

var idCounter = 0;

var TextInputField =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(TextInputField, _PureComponent);

  function TextInputField() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, TextInputField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(TextInputField)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      id: (_this.props.id || idCounter++).toString()
    });
    return _this;
  }

  (0, _createClass2.default)(TextInputField, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          unusedId = _this$props.id,
          hint = _this$props.hint,
          label = _this$props.label,
          description = _this$props.description,
          validationMessage = _this$props.validationMessage,
          inputHeight = _this$props.inputHeight,
          inputWidth = _this$props.inputWidth,
          disabled = _this$props.disabled,
          required = _this$props.required,
          isInvalid = _this$props.isInvalid,
          appearance = _this$props.appearance,
          placeholder = _this$props.placeholder,
          spellCheck = _this$props.spellCheck,
          props = (0, _objectWithoutProperties2.default)(_this$props, ["id", "hint", "label", "description", "validationMessage", "inputHeight", "inputWidth", "disabled", "required", "isInvalid", "appearance", "placeholder", "spellCheck"]);
      var id = "TextInputField-".concat(this.state.id);
      /**
       * Split the wrapper props from the input props.
       */

      var _splitBoxProps = (0, _uiBox.splitBoxProps)(props),
          matchedProps = _splitBoxProps.matchedProps,
          remainingProps = _splitBoxProps.remainingProps;

      return _react.default.createElement(_formField.FormField, (0, _extends2.default)({
        marginBottom: 24,
        label: label,
        isRequired: required,
        hint: hint,
        description: description,
        validationMessage: validationMessage,
        labelFor: id
      }, matchedProps), _react.default.createElement(_TextInput.default, (0, _extends2.default)({
        id: id,
        width: inputWidth,
        height: inputHeight,
        disabled: disabled,
        required: required,
        isInvalid: isInvalid,
        appearance: appearance,
        placeholder: placeholder,
        spellCheck: spellCheck
      }, remainingProps)));
    }
  }]);
  return TextInputField;
}(_react.PureComponent);

exports.default = TextInputField;
TextInputField.displayName = "TextInputField";
(0, _defineProperty2.default)(TextInputField, "propTypes", (0, _objectSpread2.default)({}, _TextInput.default.propTypes, _formField.FormField.propTypes, {
  /**
   * The label used above the input element.
   */
  label: _propTypes.default.node.isRequired,

  /**
   * Passed on the label as a htmlFor prop.
   */
  labelFor: _propTypes.default.string,

  /**
   * Wether or not show a asterix after the label.
   */
  isRequired: _propTypes.default.bool,

  /**
   * A optional description of the field under the label, above the input element.
   */
  description: _propTypes.default.node,

  /**
   * A optional hint under the input element.
   */
  hint: _propTypes.default.node,

  /**
   * If a validation message is passed it is shown under the input element
   * and above the hint. This is unaffected by `isInvalid`.
   */
  validationMessage: _propTypes.default.node,

  /**
   * The height of the input element.
   */
  inputHeight: _propTypes.default.number,

  /**
   * The width of the input width.
   */
  inputWidth: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
}));
(0, _defineProperty2.default)(TextInputField, "defaultProps", {
  /**
   * The input width should be as wide as the form field.
   */
  inputWidth: '100%',
  inputHeight: 32
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./~/evergreen-ui/commonjs/text-input/src/TextInputField.js
// module id = 215
// module chunks = 0